import {useLayoutEffect} from 'react';

import {useSelector} from 'react-redux';
import {WithRouterProps} from 'react-router';

interface Props extends WithRouterProps {
  route?: {
    query: string;
  };
}

export const RedirecToLastUsedTasksDashboard = ({
  location,
  route,
  router,
}: Props): null => {
  const lastUsedDashboard = useSelector(({tasks}) => tasks.dashboard.lastUsed);

  useLayoutEffect(() => {
    router.replace({
      pathname: `${location.pathname}${lastUsedDashboard}/`,
      query: route?.query != null ? route.query : location.query,
    });
  }, []);

  return null;
};
